<template>
  <svg
    class="loader"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 640 640"
  >
    <g class="bus">
      <rect
        x="587.5"
        y="379.8"
        class="st5"
        width="22.4"
        height="11"
      />
      <polygon
        class="st5"
        points="613.5,311 606.8,314.6 606.8,285.9 613.5,289.7"
      />
      <rect
        x="28.1"
        y="379.6"
        class="st5"
        width="22.4"
        height="11"
      />
      <path
        class="st5"
        d="M589.8,276.6l-2.3-13.8c0,0-7.5-3.1-6.9,14.3c0.6,17.3-0.8,52.2-0.8,52.2s-0.6,11.7,10.2,11.4l10.4,0"
      />
      <polyline
        class="st5"
        points="600.2,378.2 601,343.5 591.4,285.9"
      />
      <g>
        <path
          class="st5"
          d="M338.7,387.5h-20.4c-1.1,0-2-0.9-2-2V285.1c0-1.1,0.9-2,2-2h20.4c1.1,0,2,0.9,2,2v100.4 C340.7,386.6,339.8,387.5,338.7,387.5z"
        />
        <path
          class="st5"
          d="M342.6,387.5h20.4c1.1,0,2-0.9,2-2V285.1c0-1.1-0.9-2-2-2h-20.4c-1.1,0-2,0.9-2,2v100.4 C340.7,386.6,341.5,387.5,342.6,387.5z"
        />
        <line
          class="st5"
          x1="343.4"
          y1="375.1"
          x2="362.3"
          y2="375.1"
        />
        <line
          class="st5"
          x1="319.2"
          y1="375.1"
          x2="338.1"
          y2="375.1"
        />
      </g>
      <g>
        <path
          class="st5"
          d="M542.8,387.5h-20.4c-1.1,0-2-0.9-2-2V285.1c0-1.1,0.9-2,2-2h20.4c1.1,0,2,0.9,2,2v100.4 C544.7,386.6,543.8,387.5,542.8,387.5z"
        />
        <path
          class="st5"
          d="M546.7,387.5h20.4c1.1,0,2-0.9,2-2V285.1c0-1.1-0.9-2-2-2h-20.4c-1.1,0-2,0.9-2,2v100.4 C544.7,386.6,545.6,387.5,546.7,387.5z"
        />
        <line
          class="st5"
          x1="547.5"
          y1="375.1"
          x2="566.4"
          y2="375.1"
        />
        <line
          class="st5"
          x1="523.3"
          y1="375.1"
          x2="542.2"
          y2="375.1"
        />
      </g>
      <path
        class="st5"
        d="M94.3,344.5H53.7c-1.1,0-2-0.9-2-2v-57.4c0-1.1,0.9-2,2-2h40.6c1.1,0,2,0.9,2,2v57.4 C96.3,343.6,95.4,344.5,94.3,344.5z"
      />
      <path
        class="st5"
        d="M148.4,344.5h-40.6c-1.1,0-2-0.9-2-2v-57.4c0-1.1,0.9-2,2-2h40.6c1.1,0,2,0.9,2,2v57.4 C150.4,343.6,149.5,344.5,148.4,344.5z"
      />
      <g>
        <path
          class="st5"
          d="M300.3,344.5H243c-1.1,0-2-0.9-2-2v-57.4c0-1.1,0.9-2,2-2h57.3c1.1,0,2,0.9,2,2v57.4 C302.3,343.6,301.4,344.5,300.3,344.5z"
        />
        <line
          class="st5"
          x1="245.9"
          y1="305.7"
          x2="296.9"
          y2="305.7"
        />
      </g>
      <g>
        <path
          class="st5"
          d="M229,344.5h-57.3c-1.1,0-2-0.9-2-2v-57.4c0-1.1,0.9-2,2-2H229c1.1,0,2,0.9,2,2v57.4 C231,343.6,230.1,344.5,229,344.5z"
        />
        <line
          class="st5"
          x1="174.7"
          y1="305.7"
          x2="225.6"
          y2="305.7"
        />
      </g>
      <g>
        <path
          class="st5"
          d="M508,344.5h-57.3c-1.1,0-2-0.9-2-2v-57.4c0-1.1,0.9-2,2-2H508c1.1,0,2,0.9,2,2v57.4 C510,343.6,509.1,344.5,508,344.5z"
        />
        <line
          class="st5"
          x1="453.7"
          y1="305.7"
          x2="504.6"
          y2="305.7"
        />
      </g>
      <g>
        <path
          class="st5"
          d="M436.7,344.5h-57.3c-1.1,0-2-0.9-2-2v-57.4c0-1.1,0.9-2,2-2h57.3c1.1,0,2,0.9,2,2v57.4 C438.7,343.6,437.8,344.5,436.7,344.5z"
        />
        <line
          class="st5"
          x1="382.4"
          y1="305.7"
          x2="433.3"
          y2="305.7"
        />
      </g>
      <path
        class="st5"
        d="M587.5,262.8l-2.4-2.6c-3.1-3.5-7.6-5.5-12.3-5.5H45.5c-5.6,0-10.1,4.5-10.1,10.1v113.8"
      />
      <line
        class="st5"
        x1="41.7"
        y1="274.3"
        x2="573.9"
        y2="274.3"
      />
      <polyline
        class="st5"
        points="324.8,254.7 310,239.8 117.5,239.8 103.1,254.2"
      />
      <path
        class="st5"
        d="M613.5,293.2c0-5.9,0.6-7.8-9.7-7.8l-22.2,0.4v-9.3l33,1.7c4,0.5,7,3.8,7,7.7v13.3c0,3.3-3,6.5-5,9.2l-1.5,2"
      />
      <line
        class="st5"
        x1="205.9"
        y1="399.9"
        x2="437.7"
        y2="399.9"
      />
      <polyline
        class="st5"
        points="36,390.6 93.8,400.6 133.6,400.6"
      />
      <polyline
        class="st5"
        points="510,400.1 587.9,400.1 600.2,391.2"
      />
      <path
        class="st6"
        d="M205.9,399.7c0-20-16.2-36.2-36.2-36.2c-20,0-36.2,16.2-36.2,36.2c0,0.1,0,0.2,0,0.3"
      />
      <path
        class="st6"
        d="M510,399.7c0-20-16.2-36.2-36.2-36.2c-20,0-36.2,16.2-36.2,36.2c0,0.1,0,0.2,0,0.3"
      />
    </g>
    <g class="wheel front-wheel">
      <g>
        <ellipse
          transform="matrix(0.2308 -0.973 0.973 0.2308 -24.3531 768.4301)"
          class="st1"
          cx="473.8"
          cy="399.6"
          rx="33.5"
          ry="33.5"
        />
        <path
          class="st2"
          d="M490.8,399.6c0,9.3-7.6,16.9-16.9,16.9c-9.3,0-16.9-7.6-16.9-16.9c0-9.3,7.6-16.9,16.9-16.9 C483.2,382.7,490.8,390.3,490.8,399.6z"
        />
        <path
          class="st3"
          d="M492.9,380.7c5.1,5.1,7.7,11.7,7.9,18.5c1.2-7.6-0.8-15.2-6.2-20.6c-5.8-5.8-14.3-7.7-22.4-5.8 C479.8,372.5,487.3,375.1,492.9,380.7z"
        />
      </g>
    </g>
    <g class="wheel back-wheel">
      <g>
        <ellipse
          transform="matrix(0.2308 -0.973 0.973 0.2308 -258.2478 472.56)"
          class="st1"
          cx="169.8"
          cy="399.6"
          rx="33.5"
          ry="33.5"
        />
        <path
          class="st2"
          d="M186.7,399.6c0,9.3-7.6,16.9-16.9,16.9c-9.3,0-16.9-7.6-16.9-16.9c0-9.3,7.6-16.9,16.9-16.9 C179.1,382.7,186.7,390.3,186.7,399.6z"
        />
        <path
          class="st3"
          d="M188.8,380.7c5.1,5.1,7.7,11.7,7.9,18.5c1.2-7.6-0.8-15.2-6.2-20.6c-5.8-5.8-14.3-7.7-22.4-5.8 C175.7,372.5,183.2,375.1,188.8,380.7z"
        />
      </g>
    </g>
    <g class="cloud">
      <path
        class="st4"
        d="M530,167.9c0.7-2.4,1-4.9,1-7.5c0-15.6-12.6-28.2-28.2-28.2c-14.1,0-25.7,10.3-27.9,23.8 c-3.3-5-8.9-8.3-15.3-8.3c-10.1,0-18.3,8.2-18.3,18.3c0,0.7,0,1.3,0.1,2c-8.9,1-15.9,9.3-15.9,18.5c0,9.9,8,18.6,17.9,18.6h86.5 c9.9,0,17.9-8.8,17.9-18.6C547.7,176.6,539.8,167.9,530,167.9z"
      />
    </g>
    <g class="line line-1">
      <line
        class="st0"
        x1="501.6"
        y1="292.4"
        x2="612.2"
        y2="292.4"
      />
    </g>
    <g class="line line-2">
      <line
        class="st0"
        x1="223"
        y1="352.8"
        x2="268.8"
        y2="352.8"
      />
    </g>
    <line
      class="line line-floor"
      x1="12.2"
      y1="440.1"
      x2="307.6"
      y2="440.1"
    />
    <line
      class="line line-floor-2"
      x1="8.2"
      y1="440.1"
      x2="280.6"
      y2="440.1"
    />
  </svg>
</template>
<script>
export default {
  name: 'LoadingSvg',
  data () {
    return {
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/components/_loadingSvg.scss';
</style>
